import { DocumentCategory } from "common";

export interface RequirementData {
  requirementId: number;
  indicatorType: RequirementsIndicatorType;
  name: string;
  documents?: RequirementDocumentData[];
  description?: string;
  isUploadActionVisible?: boolean;
  isUploadActionDisabled?: boolean;
  maxDocumentsCountToUpload?: number;
  category?: DocumentCategory;
  isValid: boolean;
  useLoaderWhenDownloading?: boolean;
  useLoaderWhenDeleting?: boolean;
  useLoaderWhenUploading?: boolean;
  isLoading: boolean;
}

export interface RequirementDocumentData {
  id: number;
  name: string;
  isRemovable: boolean;
  isDownloadable: boolean;
  isLabelVisible: boolean;
}

export enum RequirementsIndicatorType {
  Met = "met",
  InProgress = "inProgress",
  Incomplete = "incomplete"
}
